import './utils/modernizr';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import * as filters from './filters';
// import './registerServiceWorker';

Vue.config.productionTip = false;

/* register global utility filters. */
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
